import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon, { IconSizes } from '../../../components/foundations/Icon';
import { MAX_RULE_NAME_LENGTH } from '../constants';
import css from '../style.css';

const renderHighlighted = (name, searchText) => {
    if (!searchText) return name;
    const index = name.toLowerCase().indexOf(searchText.toLowerCase());
    if (index === -1) return name;
    return (
        <span>
            {name.substr(0, index)}
            <b>{name.substr(index, searchText.length)}</b>
            {name.substr(index + searchText.length)}
        </span>
    );
};

const RuleNameCell = ({ rule, editing, searchText = '', editRule }) => {
    const editable = editing && !rule.generated;

    return (
        <div className={css.nameCell}>
            <span className={classNames(css.caret, { [css.caretOpen]: editing })} />
            {editable ? (
                <div className={classNames(css.nameEdit, { [css.invalid]: rule.invalidName && !rule.name })}>
                    <input
                        type="text"
                        className={css.nameInput}
                        value={rule.name}
                        maxLength={MAX_RULE_NAME_LENGTH}
                        onClick={e => e.stopPropagation()}
                        onChange={e => editRule(rule.id, 'name', e.target.value.replace(/\n/g, ''))}
                    />
                    <Icon name="pencil" size={IconSizes.X_SMALL} />
                </div>
            ) : (
                <div className={css.nameText}>{renderHighlighted(rule.name, searchText)}</div>
            )}
        </div>
    );
};

RuleNameCell.propTypes = {
    rule: PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        generated: PropTypes.bool,
        invalidName: PropTypes.bool,
    }).isRequired,
    editing: PropTypes.bool,
    searchText: PropTypes.string,
    editRule: PropTypes.func.isRequired,
};

export default RuleNameCell;
